import { ColDef } from "ag-grid-community";
import {CompletedTime} from "src/app/utility/commonColDef";

export const SubscriptionRegionColumnDefinition: ColDef[] = [
  {
    headerName: "Subscription Id",
    field: "SubscriptionId",
    resizable: true,
    sortable: true,
  },
  {
    headerName: "Region",
    field: "Region",
    resizable: true,
    sortable: true,
  },
  CompletedTime,
  {
    headerName: "Source",
    field: "Source",
    resizable: true,
    sortable: true,
  },
];
